export const PDP_PASSWORD_RESET_ORIGIN = 'pdp password reset';

export const contactDealerModalTypes = {
    MAKE_OFFER: 'MAKE_OFFER',
    CONFIRMATION: 'CONFIRMATION',
    CONTACT_DEALER: 'CONTACT_DEALER',
    REQUEST_CUSTOMIZATION: 'REQUEST_CUSTOMIZATION',
    REQUEST_IMAGES: 'REQUEST_IMAGES',
    REQUEST_PRICE: 'REQUEST_PRICE',
    ERROR: 'ERROR',
    LOADING: 'LOADING',
    CONSULT_AN_EXPERT: 'CONSULT_AN_EXPERT',
    CONSULT_AN_EXPERT_CONFIRMATION: 'CONSULT_AN_EXPERT_CONFIRMATION',
    SHIPPING_QUOTE_REQUEST: 'SHIPPING_QUOTE_REQUEST',
};

export const SHOW_CONTACT_DEALER_PARAM = 'showContactDealer';
